import { Controller } from "@hotwired/stimulus"
// import Turbolinks from "turbolinks"

export default class ActivityListController extends Controller {
  static targets = ["row"]
  static values = { path: String }

  showActivity() {
    // TODO: need to fix this
    // Turbolinks.visit(this.pathValue)
  }
}
